import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>

            <section className="section-breadcrumb main-wrapper" style={{ overflow: "hidden" }}>
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">Our gallery</span>
                            </nav>
                            <h1 className="breadcrumb-title">Our Gallery</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-service" style={{ marginTop: "-40px" }}>
                <div className="section-space section-space-bottom-huge">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-8 col-xxl-6">
                                <div className="section-content-block text-center mb-5">
                                    <span className="section-tag">Welcome to Rahul Logistics Katni</span>
                                    <h2 className="section-title">
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            Our Gallery
                                        </div>
                                    </h2>
                                    <p className="section-text max-width-sm">we are
                                        committed to providing the best services to ensure your success.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/Blog_1.png" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/Blog_2.png" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/Blog_3.png" alt="service-thumbnail-3" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-1.jpg" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-1.svg" alt="service-icon-1" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-1.svg" alt="service-icon-hover-1" width={41} height={41} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-2.jpg" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-2.svg" alt="service-icon-1" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-2.svg" alt="service-icon-hover-1" width={41} height={41} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-3.jpg" alt="service-thumbnail-3" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-3.svg" alt="service-icon-3" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-3.svg" alt="service-icon-hover-1" width={41} height={41} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-4.jpg" alt="service-thumbnail-4" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-4.svg" alt="service-icon-4" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-4.svg" alt="service-icon-hover-4" width={41} height={41} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-5.jpg" alt="service-thumbnail-5" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-5.svg" alt="service-icon-5" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-5.svg" alt="service-icon-hover-5" width={41} height={41} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-6.jpg" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_11.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_8.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_0.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_1.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_2.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_3.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_4.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_5.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_6.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_7.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_9.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/img/gallery_10.webp" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default Gallery